import React from 'react'

import { Dialog, DialogBody, DialogHeader } from '../../../components'
import ChartLayout from '../../../models/chart_layout'
import { ChartAutoSaveNotes } from './auto-save-notes'

interface INoteDialog {
  dialogState: any
  chartLayoutModel: ChartLayout
}

export function AutoSaveNotesDialog({ dialogState, chartLayoutModel }: INoteDialog) {
  return (
    <Dialog isDraggable isBackdropDisabled state={dialogState} aria-label="Chart notes" className="w-96">
      <DialogHeader onCloseClick={() => dialogState.hide()}>Notes</DialogHeader>
      <DialogBody>
        {(dialogState.visible || dialogState.animating) && <ChartAutoSaveNotes chartLayoutModel={chartLayoutModel} />}
      </DialogBody>
    </Dialog>
  )
}
